<div
  class="content-max-width steps-helper"
  [fxHide.lt-md]="true"
  [fxHide.md]="true"
  [fxHide.gt-md]="false"
  fxLayout="row"
>
  <app-step-header-step
    *ngFor="let step of steps;"
    [stepItem]="step"
  ></app-step-header-step>
</div>
